export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-graph-trend-a3ba5753924834b3d7dd2bc6dfbcb777.svg";